// extracted by mini-css-extract-plugin
export default {"slide":"styles_slide__IEC1B","logo":"styles_logo__R7ttN"};